import React, {Component} from 'react';
import boldIcon from './bold.png';
import {toolWidth} from "../../twoLinesEditorToolsSpace";
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

class BoldTool extends Component {

    constructor(props) {
        super(props);
        this.state = {
            btnChecked:false
        }
    }
    /**
     * 监听内容变化
     */
    listenContentChange(){
        let bold = this.props.editor.queryCommandState("bold");
        this.setState({btnChecked: bold === 1});
    }

    /**
     * 监听编辑器点击
     */
    listenContentClick(){
        let bold = this.props.editor.queryCommandState("bold");
        this.setState({btnChecked: bold === 1});
    }


    render() {
        let style = {};
        if(this.state.btnChecked){
            style.boxShadow = `-1px -1px ${EDITOR_TOOL_BTN_COLOR.checked}`;
        }else{
            if(style.boxShadow){
                delete style.boxShadow;
            }
        }
        return (
            <span style={{cursor:"pointer"}} onClick={()=>{
                this.props.editor.execCommand( 'bold' );
                this.setState({btnChecked: !this.state.btnChecked});
            }}><img className={"editor-bold-tool-btn"} style={style} width={toolWidth - 2} src={boldIcon}/>
            <style>{`
                .editor-bold-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-bold-tool-btn:hover{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                }
                .editor-bold-tool-btn:active{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                }
            `}</style>
            </span>
        );
    }
}

export default BoldTool;